export const roundedClasses = {
    "2xs": "cui-rounded-2xs",
    "xs": "cui-rounded-xs",
    "sm": "cui-rounded-sm",
    "md": "cui-rounded-md",
    "lg": "cui-rounded-lg",
    "none": "cui-rounded-none"
}